// ABOUTME: Screen 5B Better Question: the storm's question is a white cloud over the third tier while the rest of the stack dims.
// ABOUTME: find_guiding_truth sends nothing; the question cloud is local and stores nothing.

import { Box } from '@mui/material';
import { useCrossingContent } from '../../../hooks/useCrossingContent';
import type { ScreenProps, ScreenResult } from '../runner/screenContract';
import ArrivalStatus from './clouds/ArrivalStatus';
import QuestionBlob from './receiver/QuestionBlob';
import { RECEIVER_HEADLINE, RECEIVER_SUB, FALLBACK_BETTER_QUESTION } from './receiver/receiverCopy';

const PRIMARY_ACTION_ID = 'find_guiding_truth';

export default function Screen5B({ crossing }: ScreenProps): ScreenResult {
  const { data: content } = useCrossingContent();
  const label = crossing.progress.actions.find(action => action.id === PRIMARY_ACTION_ID)?.label ?? '';
  const correction = crossing.storm ? content?.storms?.[crossing.storm]?.correction : null;
  // Nothing until the content arrives, so the fallback never flashes before the storm's own question.
  const question = content ? correction || FALLBACK_BETTER_QUESTION : '';

  return {
    // The headline is shared with 4B, so the button label is what the arrival announcement adds.
    layer: <ArrivalStatus text={label} />,
    cloudTiers: {
      storm: { item: crossing.storm ? content?.storms?.[crossing.storm] : undefined },
      question: <Box data-testid="better-question-cloud"><QuestionBlob question={question} /></Box>,
    },
    headline: RECEIVER_HEADLINE,
    sub: RECEIVER_SUB,
    // 4B's forgiven sky carries on behind Better Question, with no fade of its own.
    sceneSky: 'forgiven',
  };
}
